export default {
    path: '/goto/clear',
    meta: {
        title: '清理本地数据',
    },
    component: r => require.ensure([], () => r(require(`./index.vue`)), `/goto/clear`),
}


// WEBPACK FOOTER //
// ./src/views/Goto/router.js